export default __webpack_public_path__ + "static/media/professionalDetailshelp.89a090a2.png";